import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

export interface ResponsiveResizeInterface {
  breakpoint: string;
  event: Event;
  width: number;
  height: number;
}

export interface ResposiveBreakpointsInterface {
  xs: number;
  s: number;
  md: number;
  lg: number;
  xl: number;
  xxl: number;
  xxxl: number;
}

@Injectable()
export class ResponsiveService {
  private _windowWidth: number;
  private _windowHeight: number;

  private _resize: Subject<ResponsiveResizeInterface> = new Subject();

  private _breakpoint;

  private _breakpoints: ResposiveBreakpointsInterface = {
    xs: 576,
    s: 768,
    md: 992,
    lg: 1200,
    xl: 1400,
    xxl: 1600,
    xxxl: 1900
  };

  private calculateCurrentBreakpoint(): string {
    if (this._windowWidth < this._breakpoints.xs) {
      this._breakpoint = 'xs';
    } else if (this._windowWidth < this._breakpoints.s) {
      this._breakpoint = 's';
    } else if (this._windowWidth < this._breakpoints.md) {
      this._breakpoint = 'md';
    } else if (this._windowWidth < this._breakpoints.lg) {
      this._breakpoint = 'lg';
    } else if (this._windowWidth < this._breakpoints.xl) {
      this._breakpoint = 'xl';
    } else if (this._windowWidth < this._breakpoints.xxl) {
      this._breakpoint = 'xxl';
    } else {
      this._breakpoint = 'xxxl';
    }

    return this._breakpoint;
  }

  public get breakpoint(): string {
    return this._breakpoint;
  }

  public get breakpoints(): ResposiveBreakpointsInterface {
    return this._breakpoints;
  }

  public get windowWidth(): number {
    return this._windowWidth;
  }

  public get windowHeight(): number {
    return this._windowHeight;
  }

  public detectIE() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  public get resize(): Observable<ResponsiveResizeInterface> {
    return this._resize.asObservable();
  }

  public init() {
    this._windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    this._windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    this.calculateCurrentBreakpoint();

    window.addEventListener('resize', (event) => {
      this._windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      this._windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      this._resize.next({
        width: this._windowWidth,
        height: this._windowHeight,
        breakpoint: this.calculateCurrentBreakpoint(),
        event
      });
    });

    const ieVersion = this.detectIE();

    if (ieVersion) {
      window.document.getElementsByTagName('body')[0].classList.add('ie');
      window.document.getElementsByTagName('body')[0].classList.add('ie-' + ieVersion);
    }
  }

  public isMac() {
    return navigator.platform.indexOf('Mac') > -1;
  }

  public isWindows() {
    return navigator.platform.indexOf('Win') > -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/responsive/responsive.service.ts